<div class="ancillary-status">
  <div class="ancillary-status-wrapper">
    <div class="ancillary-status-chip" [class.included]="data.isIncluded">
      <img
        height="20"
        width="20"
        src="assets/icons/{{ data.isIncluded ? 'check_green' : 'close_800' }}.svg"
        alt="check"
      />
      <p class="semi-bold">{{ data.isIncluded ? 'Included' : 'Not included' }}</p>
    </div>

    <div>
      <h2 class="semi-bold pb-2">{{ data.title }}</h2>
      <p>{{ data.description }}</p>
    </div>

    <div class="ancillary-status-features">
      @for (feature of data.features; track feature) {
        <div class="ancillary-status-features-item" [class.included]="data.isIncluded">
          <img
            height="20"
            width="20"
            src="assets/icons/{{ data.isIncluded ? 'check-blue' : 'close_800' }}.svg"
            alt="check"
          />
          <p class="semi-bold">{{ feature }}</p>
        </div>
      }
    </div>

    <div
      (click)="showAllBenefits.emit(data)"
      class="text-lightblue-600 cursor-pointer d-flex g-2 align-items-center"
    >
      <p class="caption semi-bold">Show all benefits</p>
      <img
        src="assets/icons/arrow_forward_light.svg"
        alt="arrow_forward_light"
        width="16"
        height="16"
      />
    </div>
  </div>

  <img
    height="130"
    width="130"
    src="assets/images/{{ data.img }}.webp"
    alt="ancillary-bundle-item-img"
  />
</div>
